import React from "react";
import ContactInfo from "../Header/ContactInfo";
import Logo from "../Header/Logo";
import SocialMediaLinks from "../Header/SocialMediaLinks";

const ContactSection = ({ dataFooter }) => {
  return (
    <div className="px-3 2xl:container">
      <div className="rounded-custom-30 bg-footerBgColor">
        <div className="container">
          <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 sm:gap-5 gap-3  items-center md:py-[46px] py-5">
            <div className="flex justify-center sm:justify-start">
              <Logo />
            </div>
            <div className="flex justify-center sm:justify-start">
              <ContactInfo
                dataFooter={dataFooter?.static}
                image="/icons/footerCustomer.svg"
                styles="text-themePrimary"
              />
            </div>
            <div className="flex justify-center md:justify-end">
              <div className="flex flex-col gap-2">
                <span className="text-sm font-semibold leading-normal text-center text-themeSecondColor sm:text-left">
                  Temasta kalın
                </span>
                <SocialMediaLinks dataHeader={dataFooter} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
